(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const BREAKPOINT = 750;
  const cols = document.querySelectorAll('.dscnnct-footer__col');

  function syncFooterAccordion() {
    const isDesktop = window.innerWidth >= BREAKPOINT;
    cols.forEach((col) => {
      if (isDesktop) {
        col.setAttribute('open', '');
      } else {
        col.removeAttribute('open');
      }
    });
  }

  syncFooterAccordion();
  window.addEventListener('resize', syncFooterAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
